import React from "react";
import "../assets/css/portfolio.scss";
import "../App.css";
import portfolio from "../assets/portfolio.json";

const statusIcons = {
  live: "fa fa-circle",
  restricted: "fa fa-lock",
  removed: "fa fa-ban",
  info: "fa fa-briefcase",
};

const Portfolio = () => {
  return (
    <section id="projects">
      <div className="container">
        <div className="section-header">
          <span className="section-label">Selected Work</span>
          <h1 className="section-title">Projects</h1>
        </div>
        <div className="pp-container">
          {portfolio.map((work) => (
            <div className="pp-card glass-panel" key={work.name}>
              <div className="pp-img-container">
                <img src={work.img} className="p-img" alt={work.name} />
              </div>
              <div className="card-content">
                <h2 className="title">{work.name}</h2>

                {work.status && (
                  <div className="status-tags">
                    {work.status.map((s, i) =>
                      s.url ? (
                        <a
                          href={s.url}
                          target="_blank"
                          rel="noreferrer"
                          className={`status-tag status-${s.type} status-tag--link`}
                          key={i}
                        >
                          <i className={statusIcons[s.type]}></i>
                          {s.label}
                        </a>
                      ) : (
                        <span className={`status-tag status-${s.type}`} key={i}>
                          <i className={statusIcons[s.type]}></i>
                          {s.label}
                        </span>
                      )
                    )}
                  </div>
                )}

                <p className="desc">{work.desc}</p>
                <div className="tools">
                  {work.tools.map((t, i) => (
                    <span className="tool-tag" key={i}>
                      {t}
                    </span>
                  ))}
                </div>
                <div className="cta">
                  {!work.isMobile && work.link && (
                    <a href={work.link} target="_blank" rel="noreferrer">
                      <button className="btn btn-primary">
                        Visit <i className="fa fa-external-link"></i>
                      </button>
                    </a>
                  )}
                  {work.isMobile && work.play_store_link && work.app_store_link && (
                    <div className="mobile-links">
                      <a href={work.play_store_link} target="_blank" rel="noreferrer">
                        <button className="btn">
                          Play Store <i className="fa fa-android"></i>
                        </button>
                      </a>
                      <a href={work.app_store_link} target="_blank" rel="noreferrer">
                        <button className="btn">
                          App Store <i className="fa fa-apple"></i>
                        </button>
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
